export default class ListRangeManager {
  constructor(params = {}) {
    
    this.total = params.total // 120
    console.log(this.total)
    this.size = params.size  // 30
    this.totalPage = Math.ceil(params.total / params.size)
    this.currPage = null
  }
  setStartPage(pageNum) {
    pageNum < 2 && (pageNum = 2)
    this.currPage = pageNum
    return this.getRange()
  }
  getRange() {
    let start = this.size * this.currPage - this.size * 2
    start < 0 && (start = 0)
    let end = this.size * this.currPage + this.size - 1
    end + 1 > this.total && (end = this.total - 1)
    return {
      start,
      end
    }
  }
  curr() {
    return this.getRange()
  }
  next() {
    if(this.currPage < this.totalPage-1) {
      this.currPage ++
      return this.getRange()
    }
  }
  prev() {
    if(this.currPage > 2) {
      this.currPage --
      return this.getRange()
    }
  }
}


// WEBPACK FOOTER //
// ./src/util/ListRangeManager.js